export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/d7263ee1-04a5-4b24-aa8b-9a2731a5ddcc/images/dd0e0fc3048444c43f4daf413d9e5dcbd6c7717587020a264bc571a81f1996b9.jpeg",
  festival: "https://static.prod-images.emergentagent.com/jobs/d7263ee1-04a5-4b24-aa8b-9a2731a5ddcc/images/3374f859ee1f087c39edff8526b1601b46f5083049af760db0d52bd8adec78dd.jpeg",
  moving: "https://static.prod-images.emergentagent.com/jobs/d7263ee1-04a5-4b24-aa8b-9a2731a5ddcc/images/fd1a22a9901cd568088de449d9287c6becaa2e1b2f3299ec11c6a7a867e73dbe.jpeg",
  elderly: "https://images.pexels.com/photos/7345427/pexels-photo-7345427.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  wedding: "https://images.unsplash.com/photo-1652374968229-a66a1c170c04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  market: "https://images.unsplash.com/photo-1760262492882-696bc364fae2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Service categories. `id` maps to booking form option value (stable, language-independent).
export const SERVICES = [
  {
    id: "shopping",
    icon: "shopping-bag",
    en: {
      title: "Shopping Assistance",
      items: [
        "Carry shopping bags",
        "Accompany you during shopping",
        "Multi-store shopping assistance",
        "Wedding & festival shopping",
        "Market errands",
        "Help organise purchases",
      ],
    },
    hi: {
      title: "शॉपिंग में मदद",
      items: [
        "शॉपिंग बैग उठाना",
        "शॉपिंग के दौरान साथ चलना",
        "कई दुकानों में मदद",
        "शादी व त्योहार की शॉपिंग",
        "बाज़ार के छोटे काम",
        "खरीदारी व्यवस्थित करना",
      ],
    },
  },
  {
    id: "home_moving",
    icon: "package",
    en: {
      title: "Shifting & Carrying Help",
      note: "Not packers & movers — human help for small, local tasks.",
      no: "House cleaning, packing service, heavy furniture lifting.",
      items: [
        "Move boxes / items within the home",
        "Help shift things around",
        "Carry items up or down stairs",
        "Pick up or move purchased items",
        "General physical assistance",
      ],
    },
    hi: {
      title: "सामान शिफ्टिंग व उठाने में मदद",
      note: "पैकर्स-मूवर्स नहीं — छोटे, लोकल कामों के लिए इंसानी मदद।",
      no: "घर की सफ़ाई, पैकिंग सर्विस, भारी फ़र्नीचर उठाना।",
      items: [
        "घर के अंदर बॉक्स/सामान हटाना",
        "चीज़ें इधर-उधर करने में मदद",
        "सीढ़ियों से सामान ऊपर-नीचे ले जाना",
        "खरीदा हुआ सामान उठाना/लाना",
        "सामान्य शारीरिक मदद",
      ],
    },
  },
  {
    id: "errands",
    icon: "footprints",
    en: {
      title: "Errands",
      items: [
        "Pick up items",
        "Drop off items",
        "Collect purchases",
        "Queue / waiting assistance",
        "Small local errands",
        "Last-minute assistance",
      ],
    },
    hi: {
      title: "छोटे-मोटे काम (Errands)",
      items: [
        "सामान लेकर आना",
        "सामान पहुँचाना",
        "खरीदारी कलेक्ट करना",
        "लाइन में लगना / इंतज़ार",
        "छोटे लोकल काम",
        "आख़िरी वक़्त की मदद",
      ],
    },
  },
  {
    id: "family",
    icon: "users",
    en: {
      title: "Family Assistance",
      note: "Non-medical assistance only — not nursing or healthcare.",
      items: [
        "Help when guests come over",
        "Shopping assistance",
        "Local travel assistance",
        "Market assistance",
        "General non-medical help",
      ],
    },
    hi: {
      title: "परिवार की मदद",
      note: "सिर्फ़ ग़ैर-चिकित्सा मदद — नर्सिंग या हेल्थकेयर नहीं।",
      items: [
        "मेहमानों के आने पर मदद",
        "शॉपिंग में मदद",
        "लोकल आने-जाने में मदद",
        "बाज़ार में मदद",
        "सामान्य ग़ैर-चिकित्सा मदद",
      ],
    },
  },
  {
    id: "events",
    icon: "party-popper",
    en: {
      title: "Events & Weddings",
      items: [
        "Shopping assistance",
        "Guest assistance",
        "Event errands",
        "Moving small items",
        "Last-minute purchases",
        "Local coordination support",
      ],
    },
    hi: {
      title: "इवेंट व शादियाँ",
      items: [
        "शॉपिंग में मदद",
        "मेहमानों की मदद",
        "इवेंट के छोटे काम",
        "छोटा सामान इधर-उधर करना",
        "आख़िरी वक़्त की खरीदारी",
        "लोकल कोऑर्डिनेशन",
      ],
    },
  },
  {
    id: "homehelp",
    icon: "home",
    en: {
      title: "Home Help (light tasks)",
      items: ["Light dusting only: fans, shelves, cupboard tops", "Festival decoration help", "Moving and rearranging furniture or boxes", "Waiting at home for a delivery or repair person", "Help at small events"],
      note: "Light tasks only. We are not a cleaning service.",
      no: "House cleaning (sweeping, mopping, bathroom, kitchen, utensils), whitewashing, painting.",
    },
    hi: {
      title: "घर की मदद (हल्के काम)",
      items: ["सिर्फ़ हल्की धूल हटाना: पंखे, शेल्फ़, अलमारी के ऊपर", "त्योहार की सजावट में मदद", "फ़र्नीचर या बॉक्स हटाना और जमाना", "डिलीवरी या रिपेयर वाले का घर पर इंतज़ार", "छोटे इवेंट में मदद"],
      note: "सिर्फ़ हल्के काम। हम सफ़ाई सेवा नहीं हैं।",
      no: "घर की सफ़ाई (झाड़ू, पोछा, बाथरूम, किचन, बर्तन), पुताई, पेंटिंग।",
    },
  },
  {
    id: "personal",
    icon: "hand-helping",
    en: {
      title: "Personal Assistance",
      items: ["A flexible category for anything that doesn't fit neatly elsewhere.", "Tell us what you need — we'll figure it out."],
    },
    hi: {
      title: "पर्सनल असिस्टेंस",
      items: ["एक फ्लेक्सिबल कैटेगरी — जो बाक़ी में फिट न हो।", "बस बताइए क्या चाहिए — हम संभाल लेंगे।"],
    },
  },
];

export const SITUATIONS = [
  {
    img: "market",
    en: { q: "\u201CI bought too much stuff.\u201D", d: "Festival shopping. Multiple bags. Clothes, gifts, groceries, boxes. Don't struggle carrying everything." },
    hi: { q: "\u201Cबहुत सारा सामान ख़रीद लिया।\u201D", d: "त्योहार की शॉपिंग। ढेर सारे बैग। कपड़े, गिफ्ट, राशन, बॉक्स। अकेले उठाने की ज़रूरत नहीं।" },
  },
  {
    img: "hero",
    en: { q: "\u201CI need someone to help me shop.\u201D", d: "10 shops in one day during wedding season? A CHELA accompanies you, carries bags and helps organise every purchase." },
    hi: { q: "\u201Cशॉपिंग में किसी की मदद चाहिए।\u201D", d: "शादी के सीज़न में एक दिन में 10 दुकानें? एक CHELA साथ चलेगा, बैग उठाएगा और हर खरीदारी संभालेगा।" },
  },
  {
    img: "moving",
    en: { q: "\u201CI just need someone for a few hours.\u201D", d: "Moving things, collecting something, waiting somewhere, an errand or help at home. Book a CHELA by the hour." },
    hi: { q: "\u201Cबस कुछ घंटों के लिए कोई चाहिए।\u201D", d: "सामान हटाना, कुछ लाना, कहीं इंतज़ार, कोई काम या घर पर मदद। घंटे के हिसाब से CHELA बुक करें।" },
  },
  {
    img: "elderly",
    en: { q: "\u201CMy parents need help.\u201D", d: "An elderly parent going shopping, travelling locally, visiting a market or handling luggage. CHELA provides local assistance." },
    hi: { q: "\u201Cमेरे माता-पिता को मदद चाहिए।\u201D", d: "बुज़ुर्ग माता-पिता की शॉपिंग, लोकल आना-जाना, बाज़ार या सामान संभालना। CHELA लोकल मदद देता है।" },
  },
  {
    img: "festival",
    en: { q: "\u201CI need help during an event.\u201D", d: "Wedding shopping, event setup, guest assistance, last-minute errands and moving items. CHELA helps you get it done." },
    hi: { q: "\u201Cइवेंट में मदद चाहिए।\u201D", d: "शादी की शॉपिंग, इवेंट सेटअप, मेहमानों की मदद, आख़िरी काम और सामान हटाना। CHELA सब संभाल लेगा।" },
  },
];

export const FAQS = [
  { en: { q: "What is CHELA?", a: "CHELA is a hyperlocal, on-demand human assistance service. In simple words — book a reliable person when you need an extra pair of hands for a few hours." },
    hi: { q: "CHELA क्या है?", a: "CHELA एक हाइपरलोकल, ऑन-डिमांड ह्यूमन असिस्टेंस सर्विस है। आसान शब्दों में — जब कुछ घंटों के लिए मदद चाहिए, एक भरोसेमंद इंसान बुक करें।" } },
  { en: { q: "What can a CHELA help me with?", a: "Personal assistance, family and household help, errands and queues, light home help (light dusting of fans and shelves, rearranging — no house cleaning), events and functions, and market help." },
    hi: { q: "एक CHELA किन कामों में मदद करेगा?", a: "पर्सनल असिस्टेंस, घर-परिवार की मदद, छोटे काम व लाइन में खड़े रहना, घर का हल्का काम (पंखे-शेल्फ़ की हल्की धूल, सामान जमाना — घर की सफ़ाई नहीं), इवेंट व फ़ंक्शन, और बाज़ार के काम।" } },
  { en: { q: "How do I book?", a: "Tap 'Book a CHELA', choose the service, date and time slot, and pay online. Your address is picked up automatically and your booking is confirmed as soon as payment is done." },
    hi: { q: "बुक कैसे करें?", a: "'Book a CHELA' दबाएँ, सर्विस, तारीख़ और समय स्लॉट चुनें और ऑनलाइन पेमेंट करें। आपका पता अपने-आप ले लिया जाता है और पेमेंट होते ही बुकिंग कन्फ़र्म।" } },
  { en: { q: "Can I book for only one hour?", a: "Yes. The minimum booking is 1 hour." },
    hi: { q: "क्या सिर्फ़ एक घंटे के लिए बुक कर सकते हैं?", a: "हाँ। कम से कम बुकिंग 1 घंटे की है।" } },
  { en: { q: "Can I book someone for market help?", a: "Yes — a CHELA can go with you to the market and help with whatever you need while you shop." },
    hi: { q: "क्या बाज़ार के काम के लिए बुक कर सकते हैं?", a: "हाँ — एक CHELA आपके साथ बाज़ार जाएगा और खरीदारी के दौरान हर ज़रूरी मदद करेगा।" } },
  { en: { q: "Is CHELA a healthcare or nursing service?", a: "No. CHELA is everyday human help for busy people: personal assistance, errands, home help and events. We do not provide medical or nursing care." },
    hi: { q: "क्या CHELA हेल्थकेयर या नर्सिंग सर्विस है?", a: "नहीं। CHELA व्यस्त लोगों के लिए रोज़ की मदद है: पर्सनल असिस्टेंस, ज़रूरी काम, घर की मदद और इवेंट्स। हम मेडिकल या नर्सिंग सेवा नहीं देते।" } },
  { en: { q: "Does CHELA provide professional movers?", a: "No. CHELA is human assistance for small, local tasks — not a professional packers-and-movers company for full household relocation." },
    hi: { q: "क्या CHELA प्रोफेशनल मूवर्स देता है?", a: "नहीं। CHELA छोटे, लोकल कामों के लिए इंसानी मदद है — पूरे घर की शिफ्टिंग वाली पैकर्स-मूवर्स कंपनी नहीं।" } },
  { en: { q: "Does CHELA provide medical care?", a: "No. CHELA does not provide medical care, nursing or healthcare of any kind." },
    hi: { q: "क्या CHELA चिकित्सा सेवा देता है?", a: "नहीं। CHELA किसी भी तरह की चिकित्सा, नर्सिंग या हेल्थकेयर सेवा नहीं देता।" } },
  { en: { q: "How are CHELA partners verified?", a: "Every CHELA is verified with ID, selfie, a local reference and a background check before their first job. After every job, customers rate their CHELA." },
    hi: { q: "CHELA पार्टनर्स कैसे वेरिफाई होते हैं?", a: "हर CHELA की पहले जॉब से पहले ID, सेल्फ़ी, लोकल रेफ़रेंस और बैकग्राउंड वेरिफ़िकेशन होता है। हर काम के बाद ग्राहक अपने CHELA को रेटिंग देते हैं।" } },
  { en: { q: "How is pricing calculated?", a: "It is {std}/hour. Minimum booking is 1 hour. Waiting time is billed. A travel charge may apply for far locations." },
    hi: { q: "कीमत कैसे तय होती है?", a: "{std}/घंटा। कम से कम 1 घंटे की बुकिंग। इंतज़ार का समय बिल होता है। दूर की लोकेशन पर ट्रैवल चार्ज लग सकता है।" } },
  { en: { q: "Which cities are currently available?", a: "We are now live in Bhopal. Indore, Jabalpur, Gwalior, Nagpur and more are coming soon — join the waitlist for your city." },
    hi: { q: "अभी कौन-से शहर उपलब्ध हैं?", a: "हम पहले भोपाल में शुरू कर रहे हैं। इंदौर, जबलपुर, ग्वालियर, नागपुर और अन्य जल्द — अपने शहर के लिए वेटलिस्ट जॉइन करें।" } },
  { en: { q: "Can I request a specific type of assistance?", a: "Yes. Pick a service or simply describe your task in the booking form. Personal Assistance covers anything that doesn't fit a category." },
    hi: { q: "क्या मैं ख़ास तरह की मदद माँग सकता हूँ?", a: "हाँ। सर्विस चुनें या बुकिंग फ़ॉर्म में अपना काम लिखें। पर्सनल असिस्टेंस बाक़ी सब कुछ कवर करती है।" } },
  { en: { q: "What happens after I pay?", a: "Your booking is confirmed instantly. Your location and task details reach us, we assign a verified CHELA, and they arrive at your location at the chosen time. No cash on delivery." },
    hi: { q: "पेमेंट के बाद क्या होता है?", a: "बुकिंग तुरंत कन्फ़र्म हो जाती है। आपकी लोकेशन और काम की जानकारी हमें मिलती है, हम एक वेरिफाइड CHELA भेजते हैं, और वह चुने हुए समय पर आपकी लोकेशन पर पहुँचता है। कैश ऑन डिलीवरी नहीं।" } },
];


const SERVICE_ORDER = ["personal", "family", "errands", "homehelp", "events", "home_moving", "shopping"];
SERVICES.sort((a, b) => SERVICE_ORDER.indexOf(a.id) - SERVICE_ORDER.indexOf(b.id));

SITUATIONS[0] = {
  img: "personal",
  en: { q: "\u201CI need an extra pair of hands today.\u201D", d: "A bank visit, a parcel, a home to set up for guests, a task you have no time for. Book a CHELA for a few hours." },
  hi: { q: "\u201C\u0906\u091c \u0915\u093f\u0938\u0940 \u0915\u0940 \u092e\u0926\u0926 \u091a\u093e\u0939\u093f\u090f\u0964\u201D", d: "\u092c\u0948\u0902\u0915 \u0915\u093e \u0915\u093e\u092e, \u090f\u0915 \u092a\u093e\u0930\u094d\u0938\u0932, \u092e\u0947\u0939\u092e\u093e\u0928\u094b\u0902 \u0915\u0947 \u0932\u093f\u090f \u0918\u0930 \u0924\u0948\u092f\u093e\u0930 \u0915\u0930\u0928\u093e\u0964 \u0915\u0941\u091b \u0918\u0902\u091f\u094b\u0902 \u0915\u0947 \u0932\u093f\u090f CHELA \u092c\u0941\u0915 \u0915\u0930\u0947\u0902\u0964" },
};
